import { Input as MUIInput, InputProps } from '@mui/material';

export { type InputProps } from '@mui/material';

export function Input(props: InputProps) {
  return <MUIInput {...props} />;
}
